// extracted by mini-css-extract-plugin
export default {"CardTile":"CardTile_CardTile__kTSFC","card-img":"CardTile_card-img__BcZ0x"};